export const getFormattedDouble = (d: number | string): string => {
  const n = Math.round(d * 100) / 100;

  return Number(parseFloat(`${n}`))
    .toLocaleString(
      'pt-BR',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    );
};

export const getOnlyNumbers = (value: string): string => {
  if (value) {
    return value.replace(/\D/g, '');
  }
  return '';
};

export const formatCPF = (cpf: string): string => {
  const numbers = cpf?.replace(/[^\d]/g, '');

  return numbers?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatBP = (bpOrigValue: string): string => {
  const newValue = bpOrigValue.replace(/^0+/, '');

  if (newValue.length < 10) {
    return newValue.padStart(10, '0');
  }

  return bpOrigValue;
};

// input: XXXXXXXXYYYYZZ (X, Y, Z: digits)
// output: XX.XXX.XXX/YYYY-ZZ
export const formatCnpj = (unformattedString: string): string => {
  const inputArray = unformattedString.toString().match(/\d/g);

  if (!inputArray) {
    return unformattedString;
  }

  const input = inputArray.join('');

  if (input.length < 14) {
    return unformattedString;
  }

  const suffix = input.substr(input.length - 6);
  const prefix = input.substr(0, input.length - 6);

  let finalPrefix = '';

  for (let i = prefix.length - 1; i >= 0; i -= 1) {
    finalPrefix = `${prefix.charAt(i)}${finalPrefix}`;

    if (i > 0 && (prefix.length - i) % 3 === 0) {
      finalPrefix = `.${finalPrefix}`;
    }
  }

  const finalSuffix = `${suffix.substr(0, 4)}-${suffix.substr(4)}`;

  return `${finalPrefix}/${finalSuffix}`;
};

export const formatTelephone = (rawValue: string): string => {
  if (!rawValue) {
    return '';
  }

  const value = rawValue.replace(/\D/g, ''); // Only numbers

  if (value.length === 0) {
    return '';
  }

  if (value.length === 1 || value.length === 2) {
    return `(${value.slice(0, 2)}`;
  }

  if (value.length >= 3 && value.length <= 6) {
    return `(${value.slice(0, 2)}) ${value.slice(2, 6)}`;
  }

  if (value.length <= 10) {
    return `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6, 10)}`;
  }

  return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
};
